import { StyleSheet, Text, View } from "@react-pdf/renderer";
import { t } from "i18next";
import { DateTime } from "luxon";

import { FolderFileType } from "src/core/components/pdf/shared/types";
import { User } from "src/core/gql/graphql";

const styles = StyleSheet.create({
  footer: {
    position: "absolute",
    bottom: 20,
    left: 24,
    right: 24,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    fontSize: 10,
  },
  leftText: {
    flex: 1,
    fontSize: 9,
    marginRight: 16,
    opacity: 0.5,
  },
  pageNumber: {
    fontSize: 10,
    flexShrink: 0,
    opacity: 0.5,
  },
});

type PdfFooterProps = {
  folderFile: FolderFileType;
  currentUser: User;
};

export const PdfFooter = ({ folderFile, currentUser }: PdfFooterProps) => {
  const isPerson = folderFile.fileCustomerFolder?.customer?.isPerson;
  const allInputValues = folderFile.fileCustomerFolder?.customer?.allInputValues ?? [];
  const name = isPerson
    ? [
        allInputValues?.find((iv) => iv.inputField.fieldCode === "firstName")?.stringValue,
        allInputValues?.find((iv) => iv.inputField.fieldCode === "lastName")?.stringValue,
      ]
        .filter(Boolean)
        .join(" ")
    : allInputValues?.find((iv) => iv.inputField.fieldCode === "name")?.stringValue ?? "";

  const dateExtraction = DateTime.now().toFormat("dd/MM/yyyy");
  const ownerName = currentUser ? `${currentUser.firstName} ${currentUser.lastName}` : "";

  const footerText = t("pdf.footer.text", {
    name: name ?? "",
    date: dateExtraction,
    ownerName: ownerName || "-",
  });

  return (
    <View style={styles.footer} fixed>
      <Text style={styles.leftText} wrap>
        {footerText}
      </Text>
      <Text
        style={styles.pageNumber}
        render={({ pageNumber, totalPages }) => `Page ${pageNumber}/${totalPages}`}
      />
    </View>
  );
};
